import React, { Component } from 'react'

export default class FeatureRequestDialog extends Component {
  
  render() {
    const { id } = this.props;
    
    const featureDescMap = {
      'liveView': 'Live+(Presentation)+View',
      'resultsCustomization': 'Results+customization'
    };

    const formURL = 'https://docs.google.com/forms/d/e/1FAIpQLSf-Cof_KNpwCS44zv5asnO4wlXlbULOOcSJSzDd1f3TwIkHAw/viewform?usp=pp_url&entry.1599904759='
      + featureDescMap[id];

    return (
      <div class="modal fade" id={id} tabindex="-1" role="dialog" aria-labelledby="Feature Request Dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <iframe title="Feature request form" width="100%" height="100%" style={{border: 0, height: '75vh' }} src={formURL}>
              </iframe>
            </div>
            <div class="modal-footer modal-footer-stacked">
              <button type="button" class="btn btn-outline-info" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
